module.exports = __webpack_public_path__ + "static/img/login-bg.722d0b0a.jpg";